import qs from 'querystring'

import { takeLatest, put } from 'redux-saga/effects'

import { isEmpty } from 'helpers/lodash'
import { detectEnvironmentFromURL } from 'helpers/miscellaneous'
import { navigate } from 'helpers/navigation'
import { extractRoomNameFromURL } from 'helpers/room'
import { accessTokenHelper } from 'helpers/token'
import { isCorrectAuthTokenIssuer } from 'helpers/user'
import { performLogout } from 'store/thunks/User'

import { updateEnvironment } from '../actions/App'
import * as types from '../actionTypes/App'

function* _watchHandleDeepLinking(action) {
    try {
        const { data } = action
        console.log('deep linking data :- ', data)

        const queries = qs.parse(data)
        let roomUrl = queries['room-url']

        if (!isEmpty(roomUrl)) {
            // detect environment from url
            const environment = detectEnvironmentFromURL(roomUrl)

            // first check token issuer is proper or not , if not clear auth state
            const accessToken = accessTokenHelper.get()

            if (
                accessToken &&
                !isCorrectAuthTokenIssuer(accessToken, environment)
            ) {
                // logout
                yield put(performLogout())
            }

            console.log('updating environment :- ', environment)

            // update env in state store
            yield put(updateEnvironment(environment))

            // extract room name
            const roomName = extractRoomNameFromURL(roomUrl)

            if (roomName) {
                // navigate to room url
                navigate(`/${roomName}`)
            }
        }
    } catch (error) {
        console.log(error)
    }
}

export function* watchHandleDeepLinking() {
    yield takeLatest(types.HANDLE_DEEP_LINKING, _watchHandleDeepLinking)
}
